module.exports = __webpack_public_path__ + "img/price_type_3.802c52a2.png";